import EventEmitter from 'events'
import detect from '@metamask/detect-provider'

class MetamaskAdapter {
    provider

    eventEmitter

    connected

    accounts

    chainId

    constructor() {
        this.emitter = new EventEmitter()

        this.onAccountsChanged = this.onAccountsChanged.bind(this)
        this.onChainChanged = this.onChainChanged.bind(this)
    }

    async connect() {
        this.disconnect()

        try {
            this.provider = await detect()
            this.accounts = await this.provider.request({
                method: 'eth_requestAccounts',
            })
            this.chainId = await this.provider.request({
                method: 'eth_chainId',
            })

            this.connected = true
        } catch (e) {
            this.emitter.emit('disconnected')

            throw e
        }

        this.connected = this.accounts && this.accounts.length > 0

        this.provider.addListener('accountsChanged', this.onAccountsChanged)
        this.provider.addListener('chainChanged', this.onChainChanged)

        return this.accounts
    }

    getAccounts() {
        return this.accounts || []
    }

    getChainId() {
        return this.chainId
    }

    // eslint-disable-next-line class-methods-use-this
    canWatchAsset() {
        return true
    }

    // eslint-disable-next-line class-methods-use-this
    canSwitchChain() {
        return true
    }

    isConnected() {
        return this.connected
    }

    getProvider() {
        return this.provider
    }

    on(...args) {
        this.emitter.on(...args)
    }

    off(...args) {
        this.emitter.removeListener(...args)
    }

    onAccountsChanged(accounts) {
        this.accounts = accounts

        if (!accounts || accounts.length <= 0) {
            this.emitter.emit('disconnected')
        } else {
            this.emitter.emit('accountsChanged', accounts)
        }
    }

    onChainChanged(chainId) {
        this.chainId = chainId

        this.emitter.emit('chainChanged', chainId)
    }

    disconnect() {
        this.connected = false

        if (this.provider) {
            this.provider.removeListener('accountsChanged', this.onAccountsChanged)
            this.provider.removeListener('chainChanged', this.onChainChanged)
        }

        this.emitter.removeAllListeners()
    }
}

export default MetamaskAdapter
